var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.025 12.025H15.4625C14.95 12.025 14.525 11.6 14.525 11.0875C14.525 10.575 14.95 10.15 15.4625 10.15H22.025C22.5375 10.15 22.9625 10.575 22.9625 11.0875C22.9625 11.6 22.55 12.025 22.025 12.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.9 12.975C8.6625 12.975 8.425 12.8875 8.2375 12.7L7.3 11.7625C6.9375 11.4 6.9375 10.8 7.3 10.4375C7.6625 10.075 8.2625 10.075 8.625 10.4375L8.9 10.7125L11.05 8.5625C11.4125 8.2 12.0125 8.2 12.375 8.5625C12.7375 8.925 12.7375 9.525 12.375 9.8875L9.5625 12.7C9.3875 12.875 9.15 12.975 8.9 12.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.025 20.775H15.4625C14.95 20.775 14.525 20.35 14.525 19.8375C14.525 19.325 14.95 18.9 15.4625 18.9H22.025C22.5375 18.9 22.9625 19.325 22.9625 19.8375C22.9625 20.35 22.55 20.775 22.025 20.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.9 21.725C8.6625 21.725 8.425 21.6375 8.2375 21.45L7.3 20.5125C6.9375 20.15 6.9375 19.55 7.3 19.1875C7.6625 18.825 8.2625 18.825 8.625 19.1875L8.9 19.4625L11.05 17.3125C11.4125 16.95 12.0125 16.95 12.375 17.3125C12.7375 17.675 12.7375 18.275 12.375 18.6375L9.5625 21.45C9.3875 21.625 9.15 21.725 8.9 21.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.62b307df1e8a7e45dee9caf1eafa89ba.svg";
export { ForwardRef as ReactComponent };